import { connect } from 'react-redux';
import RelinkBankingModal from '../myAccount/revenueBasedLoan/dashboard/outstandingView/dashboardActions/RelinkBankingModal';
import RelinkBankingModalWrapperStyles from '../myAccount/revenueBasedLoan/dashboard/outstandingView/dashboardActions/RelinkBankingModal.module.css';
import SignDocumentsActionModal from '../myAccount/funding/fundingSteps/signDocumentAction/signDocumentModals/signDocumentsActionModal/SignDocumentsActionModal';
import SignDocumentsModalWrapperStyles from '../myAccount/funding/fundingSteps/signDocumentAction/signDocumentModals/SignDocumentModals.module.css';
import ViewGuarantorAgreementModal from '../myAccount/funding/fundingSteps/signDocumentAction/viewGuarantorAgreementModal/ViewGuarantorAgreementModal';
import FallbackErrorModal from '../myAccount/modals/fallbackErrorModal/FallbackErrorModal';
import FallbackErrorModalWrapperStyles from '../myAccount/modals/fallbackErrorModal/FallbackErrorModal.module.css';
import IDNowModal from '../myAccount/modals/IDNowModal/IDNowModal';
import OnfidoVerificationModal from '../myAccount/modals/onfidoVerificationModal/OnfidoVerificationModal';
import ProcessingPaymentModal from '../myAccount/modals/processingPaymentModal/ProcessingPaymentModal';
import ManualPaymentModal from '../myAccount/modals/manualPaymentModal/ManualPaymentModal';
import RepaymentScheduleModal from '../myAccount/modals/repaymentScheduleModal/RepaymentScheduleModal';
import TimeoutSessionErrorModal from '../myAccount/modals/timeoutSessionErrorModal/TimeoutSessionErrorModal';
import TimeoutSessionErrorModalWrapperStyles from '../myAccount/modals/timeoutSessionErrorModal/TimeoutSessionErrorModal.module.css';
import UploadDocumentsModal from '../myAccount/modals/uploadDocumentsModal/UploadDocumentsModal';
import SupportModalWrapperStyles from '../myAccount/ui/supportWidget/supportActionList/supportModal/SupportModal.module.css';
import AddPaymentMethodModal from '../myAccount/modals/addPaymentMethodModal/AddPaymentMethodModal';
import EditPaymentMethodModal from '../myAccount/modals/editPaymentMethodModal/EditPaymentMethodModal';
import PersonModal from '../myAccount/modals/personModal/PersonModal';
import LinkOpenBankingModal from '../myAccount/modals/linkOpenBankingModal/LinkOpenBankingModal';
import IwModal from './iwModal';
import { CLOSE_MODAL } from './Modals.actions';
import ViewSignedDocumentModal from '../myAccount/funding/fundingSteps/signDocumentAction/signDocumentModals/viewSignedDocumentModal/ViewSignedDocumentModal';
import UnlinkAccountModal from '../myAccount/tradingData/linkedAccounts/unlinkAccountModal/UnlinkAccountModal';
import HelpModal from '../myAccount/navigation/helpModal/HelpModal';
import { Dispatch } from 'redux';
import * as constants from './Modals.constants';
import { ModalIdTypes } from './Modals.types';
import { Modal } from '@iwoca/orion';
import CrossSellWarningModal from '../myAccount/iwocaPay/dashboard/CrossSellCard/CrossSellWarningModal';
import CallSupportModal from '../myAccount/ui/supportWidget/supportActionList/callSupportButtonWithModal/callSupportModal/CallSupportModal.js';

const mapStateToProps = ({ modals }: { modals: ModalIdTypes }) => modals;

const mapDispatchToProps = (dispatch: Dispatch) => ({
    closeModal: () => {
        dispatch({
            type: CLOSE_MODAL
        });
    }
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const IwModals = ({
    openModalId,
    errorModalId,
    closeModal
}: ModalIdTypes & PropsFromRedux) => {
    return (
        <>
            <IwModal
                isOpen={openModalId === constants.CALL_SUPPORT_MODAL}
                onClose={closeModal}
                contentStyles={SupportModalWrapperStyles.SupportModalWrapper}
            >
                <CallSupportModal />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.SIGN_DOCUMENTS_ACTION_MODAL}
                onClose={closeModal}
                contentStyles={SignDocumentsModalWrapperStyles.ModalWrapper}
            >
                <SignDocumentsActionModal />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.VIEW_SIGNED_DOCUMENTS_MODAL}
                onClose={closeModal}
                contentStyles={SignDocumentsModalWrapperStyles.ModalWrapper}
            >
                <ViewSignedDocumentModal />
            </IwModal>

            <IwModal
                isOpen={
                    openModalId === constants.VIEW_GUARANTOR_AGREEMENT_MODAL
                }
                onClose={closeModal}
            >
                <ViewGuarantorAgreementModal />
            </IwModal>

            <Modal
                isOpen={openModalId === constants.ADD_PAYMENT_METHOD_MODAL}
                onClose={closeModal}
                closeIcon
            >
                <AddPaymentMethodModal />
            </Modal>

            <IwModal
                isOpen={openModalId === constants.EDIT_PAYMENT_METHOD_MODAL}
                onClose={closeModal}
            >
                <EditPaymentMethodModal />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.REPAYMENT_SCHEDULE_MODAL}
                onClose={closeModal}
            >
                <RepaymentScheduleModal />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.PERSON_MODAL}
                onClose={closeModal}
            >
                <PersonModal />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.PROCESSING_PAYMENT_MODAL}
                removeClose={true}
                onClose={closeModal}
            >
                <ProcessingPaymentModal />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.MANUAL_PAYMENT_MODAL}
                onClose={closeModal}
            >
                <ManualPaymentModal />
            </IwModal>

            <IwModal
                isOpen={errorModalId === constants.TIMEOUT_SESSION_ERROR_MODAL}
                removeClose={true}
                contentStyles={
                    TimeoutSessionErrorModalWrapperStyles.TimeoutSessionErrorModalWrapper
                }
            >
                <TimeoutSessionErrorModal />
            </IwModal>

            <IwModal
                isOpen={errorModalId === constants.FALLBACK_ERROR_MODAL}
                removeClose={true}
                contentStyles={
                    FallbackErrorModalWrapperStyles.FallbackErrorModalWrapper
                }
            >
                <FallbackErrorModal />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.UPLOAD_DOCUMENTS_MODAL}
                onClose={closeModal}
            >
                <UploadDocumentsModal />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.UNLINK_LINKED_ACCOUNT_MODAL}
                onClose={closeModal}
                contentStyles={SupportModalWrapperStyles.SupportModalWrapper}
            >
                <UnlinkAccountModal />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.ONFIDO_VERIFICATION_MODAL}
                onClose={closeModal}
            >
                <OnfidoVerificationModal onClose={closeModal} />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.LINK_OPEN_BANKING_MODAL}
                removeClose={true}
                onClose={closeModal}
            >
                <LinkOpenBankingModal />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.ID_NOW_MODAL}
                onClose={closeModal}
            >
                <IDNowModal />
            </IwModal>

            <Modal
                isOpen={openModalId === constants.HELP_MODAL}
                onClose={closeModal}
                closeIcon
            >
                <HelpModal />
            </Modal>

            <IwModal
                isOpen={openModalId === constants.RELINK_BANKING_MODAL}
                onClose={closeModal}
                contentStyles={
                    RelinkBankingModalWrapperStyles.RelinkBankingModalWrapper
                }
            >
                <RelinkBankingModal />
            </IwModal>

            <IwModal
                isOpen={openModalId === constants.RELINK_EXPIRED_BANKING_MODAL}
                removeClose={true}
                contentStyles={
                    RelinkBankingModalWrapperStyles.RelinkBankingModalWrapper
                }
            >
                <RelinkBankingModal />
            </IwModal>

            <Modal
                isOpen={openModalId === constants.CROSS_SELL_WARNING_MODAL}
                onClose={closeModal}
                closeIcon
                headerBar
                title="Borrow £1,000 - £500,000 with iwoca today"
                subTitle="It only takes a few minutes to find out how much you can borrow."
            >
                <CrossSellWarningModal />
            </Modal>
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(IwModals);
